import type { ComponentPropsWithoutRef } from "react";
import { STANDARD_LAYOUT_V2_COVER_IMAGE_CONTAINER as id } from "@/react/components/constants";

export interface CoverImageContainerProps
  extends Omit<ComponentPropsWithoutRef<"div">, "id"> {}

export const CoverImageContainer = ({ ...props }: CoverImageContainerProps) => (
  <div {...props} id={id} data-testid="cover-image-container" />
);
